module.exports = __webpack_public_path__ + "static/media/24.9a94ebb0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/24.svg
// module id = 139
// module chunks = 0